import { ReactNode } from "react";
import { Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { useStyle } from "./style";
import { cls } from "itsf-ui-common";

interface IParams {
    icon: ReactNode;
    isLoading?: boolean;
    label: string;
    price: number;
    sublabel: string;
    hasBackground?: boolean;
}

export const LabelPriceTotal = (props: IParams) => {
    const { price, label, sublabel, icon, hasBackground, isLoading } = props;
    const { classes } = useStyle({ hasBackground });
    const { t } = useTranslation("common");

    return (
        <div className={classes.labelPriceTotal}>
            <div className={classes.labelPriceTotalContent}>
                <div className={classes.labelPriceTotalLeftSection}>
                    <div className={classes.labelPriceTotalIcon}>{icon}</div>
                    <Typography className={classes.labelPriceTotalLabel} variant="normal">
                        {label}
                    </Typography>
                </div>
                <Typography className={classes.labelPriceTotalSublabel} variant="small">
                    ({sublabel})
                </Typography>
            </div>
            <HandleErrorAndLoading
                isLoading={isLoading ?? false}
                skeleton={
                    <Skeleton
                        className={cls(classes.labelPriceTotalPrice, classes.priceTotalSkeleton)}
                        variant="text"
                    />
                }
            >
                <Typography className={classes.labelPriceTotalPrice} variant="normal">
                    {t("price", { price })}
                </Typography>
            </HandleErrorAndLoading>
        </div>
    );
};
